import FileAttachment from "./FileAttachment";

export default FileAttachment;
